// Client-side mirror of config/access.py's `pattern_matches`, so the nav can
// decide what to show from the grant PATTERNS `/me` returns without a round
// trip per item. Keep the two in lockstep — the backend is the gate; this only
// decides what is drawn.
//
//   *          everything
//   exact      the value itself
//   parent     a feature and all its dotted children ("trading-desk" covers
//              "trading-desk.cash")
//   glob       shell wildcards: "HJ*", "admin.*", "QWP13?0"
//
// Case-insensitive throughout.

const GLOB = /[*?[]/;

const globToRegExp = (pattern: string): RegExp => {
  let re = "";
  for (let i = 0; i < pattern.length; i++) {
    const ch = pattern[i];
    if (ch === "*") re += ".*";
    else if (ch === "?") re += ".";
    else if (ch === "[") {
      const close = pattern.indexOf("]", i + 1);
      if (close < 0) { re += "\\["; continue; }
      let body = pattern.slice(i + 1, close);
      if (body.startsWith("!")) body = "^" + body.slice(1);
      re += "[" + body.replace(/\\/g, "\\\\") + "]";
      i = close;
    } else re += ch.replace(/[.+^${}()|\\]/g, "\\$&");
  }
  return new RegExp("^" + re + "$", "i");
};

export const patternMatches = (pattern: string, value: string): boolean => {
  const p = (pattern || "").trim();
  const v = (value || "").trim();
  if (!p || !v) return p === "*" && !!v;
  if (p === "*") return true;
  const pl = p.toLowerCase();
  const vl = v.toLowerCase();
  if (pl === vl || vl.startsWith(pl + ".")) return true;
  if (GLOB.test(p)) return globToRegExp(pl).test(vl);
  return false;
};

export const anyMatches = (patterns: readonly string[], value: string): boolean =>
  patterns.some((p) => patternMatches(p, value));
